const errormessage = (errorCode: string) => {
  let message = "";
  switch (errorCode) {
    case "accessDenied":
      message = "You don't have access to this page";
      break;
    case "internalError":
      message =
        "We were unable to process this request, please try again in 60 minutes. If this error persists, please <a href='https://www.bluetooth.com/support'>contact support</a>";
      break;
    default:
      message =
        "We were unable to process this request, please try again in 60 minutes. If this error persists, please <a href='https://www.bluetooth.com/support'>contact support</a>";
  }
  return message;
};
export default errormessage;
